import { getMargin as getGlobalMargin } from './spacing.global';
export function getMargin(transformer) {
    const globalMargin = getGlobalMargin(transformer);
    return Object.freeze({
        betweenSections: { value: globalMargin.l },
        defaultBetweenItems: { value: globalMargin.m },
        underHeading: { value: globalMargin.s },
        bottomScreen: { value: globalMargin.xs },
    });
}
